import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import textimage from "./../../../../images/foods/textimage.png";
import multmedi from "./../../../../images/foods/multmedi.png";
import textandmulti from "./../../../../images/foods/textandmulti.png";
import texticon from "./../../../../images/foods/texticon.png";
import mediaicon from "./../../../../images/foods/media.png";
import audioalone from "./../../../../images/foods/audioalone.png";
import audiovideo from "./../../../../images/foods/audiovideo.png";
import template from "./../../../../images/foods/template.png";
import imagefile from "./../../../../images/foods/imagefile.png";
import FileBase64 from "react-file-base64";
import swal from "sweetalert";
const StepTwo = (props) => {
  // const [activeToggle, setActiveToggle] = useState("posts");
  // const [replayModal, setReplayModal] = useState(false);

  useEffect(() => {
    console.log("props.StepTwo", props);
    // console.log(
    //   "props.campaign_creation",
    //   props.campaign_creation.selected_message_type
    // );
  }, [props]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ align: [] }],
    ],
  };

  // formats
  const formats = [
    "header",
    "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "align",
  ];

  const onChangeFormValue = () => {
    // this.setState({ [key]: value });
  };

  const handleFileChange = (files) => {
    console.log("files", files.name);
    // console.log("files", files.size);
    const fileTotalsize = files.size.slice(0, -3);
    // console.log("fileTotalsize", fileTotalsize);
    if (parseInt(fileTotalsize) < 80000) {
      const actualbase64 = files?.base64;
      const fileType = files?.type;
      let removedprefix = actualbase64.split(",");
      let fileExtension = fileType.split("/");
      // console.log("files", removedprefix[1]);
      // console.log("fileExtension", fileExtension[1]);
      // const list = [...props.campaign_creation];
      // list[i]["file"] = removedprefix[1];
      // list[i]["fileType"] = fileExtension[1];
      // setInputList(list);
      props.handleChange("selected_message_file", removedprefix[1]);
    } else {
      swal("File Size Exceed");
    }
  };

  return (
    <>
      <h6 className="card-title">
        {props.campaign_creation.selected_message_type != "5"
          ? "Message"
          : "Location"}{" "}
      </h6>

      {props.campaign_creation.selected_message_type != "5" && (
        <div className="row">
          <div className="col-xl-2 col-lg-6"></div>
          <div className="col-xl-4 col-lg-6">
            <div className="input-group mb-3">
              <div className="form-group mb-3">
                <label className="text-label">Enter Message</label>
                <textarea
                  // value={postContent} // ...force the input's value to match the state variable...
                  onChange={(e) => {
                    // console.log("edfsgdfsg", e);
                    props.handleChange("selected_message_text", e.target.value);
                  }}
                  style={{ width: "300px", height: "100px" }}
                ></textarea>
                {/* <input
                type="textarea"
                name="textarea"
                className="form-control"
                placeholder="Type Here"
                style={{ width: "300px", height: "100px" }}
              /> */}
              </div>
            </div>
          </div>

          {props.campaign_creation.selected_message_type != "1" && (
            <div className="col-xl-4 col-lg-6">
              <div className="input-group mb-3">
                <label className="text-label">File Upload</label>
                <div className="input-group mb-3">
                  <div className="form-file">
                    {/* <input
                      type="file"
                      className="form-file-input form-control"
                    /> */}
                    <FileBase64
                      multiple={false}
                      onDone={(e) => {
                        setTimeout(function () {
                          props.handleChange("selected_message_file_name", e.name);
                        }, 1000);
                        handleFileChange(e);
                      }}
                    ></FileBase64>
                  </div>
                </div>{" "}
              </div>{" "}
            </div>
          )}
        </div>
      )}
      {props.campaign_creation.selected_message_type == "5" && (
        <div className="row">
          <div class="col">
            <div className="form-group mb-3">
              <label className="text-label">Latitude </label>
              <input
                type="number"
                name="firstName"
                className="form-control"
                placeholder="Latitude "
                required
                onChange={(e) => {
                  // console.log("edfsgdfsg", e);
                  props.handleChange("selected_Latitude", e.target.value);
                }}
              />
            </div>
          </div>
          <div class="col">
            <div className="form-group mb-3">
              <label className="text-label">Longitude </label>
              <input
                type="number"
                name="lastName"
                className="form-control"
                placeholder="longitude "
                required
                onChange={(e) => {
                  // console.log("edfsgdfsg", e);
                  props.handleChange("selected_longitude", e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StepTwo;
